import { Component } from '@angular/core';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DialogService } from '@services/dialog/dialog.service';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';

@Component({
  selector: 'app-content-pool',
  templateUrl: './content-pool-detail.component.html',
  styleUrls: ['./content-pool-detail.component.scss'],
  providers: [DynamicContentService],
  standalone: false
})
export class ContentPoolDetailComponent {
  type: string;
  columns = [{ prop: 'title', name: 'Titel' }, { prop: '_id', name: 'Sprachen', valueCallback: (data, additionalData) => this.getLanguages(data, additionalData) }];
  headerButtons = [{ icon: 'add', callback: () => this.addEntry() }];
  params: any;
  isLoading = false;
  translationsById = {};

  dynamicContentTitles = {
    information: 'Informationen', activity: 'Aktivitäten', alphabet: 'Alphabet', offer: 'Angebote', 'breaking-news': 'Breaking News', event: 'Events', feedback: 'Feedback',
    gallery: 'Gallery', gastronomy: 'Gastronomie', memory: 'Memory', new: 'News', 'public-transport': 'Öffentlicher Verkehr', 'opening-hours': 'Öffnungszeiten', person: 'Personen',
    pinboard: 'Pinboard', quiz: 'Quiz', restaurant: 'Restaurants', screensaver: 'Screensaver', 'social-media': 'Social Media', ticker: 'Ticker', voting: 'Voting', webcam: 'Webcams',
    'important-numbers': 'Wichtige Nummern', roomservice: 'Zimmerservice'
  };

  pageActions: PageAction[] = [new PageAction({ icon: 'subdirectory_arrow_left', title: 'Back', translationString: 'general.back', callback: () => this.backPage() })];

  constructor(
    private router: Router, private activatedRoute: ActivatedRoute, public dcService: DynamicContentService, private ts: TranslateService, private dialogService: DialogService
  ) {
    this.type = this.activatedRoute.snapshot.params['type'];
    this.params = { global: true, type: this.type };
    this.initItems();
  }

  async initItems() {
    const entries = await this.dcService.find(0, 1000, this.params);
    const translationIds = (entries?.data || []).map(e => e.translationEntries).flat();
    const translations = await this.fetchTranslationsBatchWise(this.dcService, translationIds, 50);
    translations.forEach(t => this.translationsById[t._id] = t);
  }

  addEntry() {
    this.router.navigate(['content-pool', this.type, 'create']);
  }

  editEntry(event: any) {
    this.router.navigate(['content-pool', this.type, event?.row?._id]);
  }

  async removeEntry(event: any) {
    const messages = this.ts.get('system');
    let confirmMessage = messages.dynamicContent.confirm_delete;
    const dialogRes = await this.dialogService.confirm(confirmMessage, '');
    if (!dialogRes) {
      return;
    }
    this.isLoading = true;
    await this.dcService.remove(event.row._id);
    this.isLoading = false;
  }

  async backPage() {
    await this.router.navigate(['content-pool']);
  }

  getLanguages(data: Models.DynamicContent, additionalData?) {
    if (Object.keys(this.translationsById).length === 0) {
      return 'de';
    }
    let languages = ['de', 'en', 'fr', 'it'];
    languages = languages.filter(l => l === data.lang || data.translationEntries.find(id => this.translationsById?.[id]?.lang === l));
    languages = languages.map(l => {
      return '<img class="language" src="../../../../../assets/img/languages/' + l + '.jpg" />';
    });
    return '<div class="languages">' + languages.join('') + '</div>';
  }

  async fetchTranslationsBatchWise(dcService: any, translationIds: string[], batchSize: number) {
    const results: any[] = [];
    for (let i = 0; i < translationIds.length; i += batchSize) {
      const batchIds = translationIds.slice(i, i + batchSize);
      const response = await dcService.find(0, batchIds.length, { _id: { $in: batchIds } });
      results.push(...response.data);
    }
    return results;
  }
}
